<template>
  <slot></slot>
</template>
<script setup lang="ts">
defineOptions({
  name: 'lp-fragment',
})
</script>
